import { useState } from 'react';

const admissions2026 = [
  { name: '○리',   university: '경기대학교',       dept: '연기학과',         category: '일반대', result: '최종합격' },
  { name: '김○찬', university: '서울예술대학교',   dept: '연기과',           category: '예대',   result: '수시1차 합격' },
  { name: '○리',   university: '한국예술종합학교', dept: '연기학과',         category: '예대',   result: '수시1차 합격' },
  { name: '이○연', university: '수원대학교',       dept: '연기예술학과',     category: '일반대', result: '수시1차 합격' },
  { name: '김○찬', university: '동서울대학교',     dept: '연기예술과',       category: '전문대', result: '수석합격' },
  { name: '이○우', university: '대진대학교',       dept: '연기예술학과',     category: '일반대', result: '최종합격' },
  { name: '김○준', university: '대진대학교',       dept: '연기예술학과',     category: '일반대', result: '최종합격' },
  { name: '천○영', university: '경민대학교',       dept: '연기예술학과',     category: '전문대', result: '최종합격' },
  { name: '김○영', university: '숭의여자대학교',   dept: '연기예술과',       category: '일반대',   result: '최종합격' },
  { name: '김○찬', university: '성결대학교',       dept: '연기예술과',       category: '일반대', result: '최종합격' },
  { name: '김○찬', university: '대진대학교',       dept: '연기예술학과',     category: '일반대', result: '최종합격' },
  { name: '정○인', university: '대진대학교',       dept: '연기예술학과',     category: '일반대', result: '최종합격' },
  { name: '박○준', university: '예원예술대학교',   dept: '연극영화과',       category: '예대',   result: '최종합격' },
  { name: '김○준', university: '백석예술대학교',   dept: '연기예술과',       category: '예대',   result: '최종합격' },
  { name: '김○영', university: '백석예술대학교',   dept: '연기예술과',       category: '예대',   result: '최종합격' },
  { name: '정○인', university: '동양대학교',       dept: '연기예술학과',     category: '일반대', result: '수석합격' },
  { name: '정○인', university: '명지전문대',       dept: '연기예술과',       category: '전문대', result: '최종합격' },
  { name: '박○준', university: '청강산업대학교',   dept: '연기전공',         category: '전문대', result: '최종합격' },
  { name: '이○연', university: '호원대학교',       dept: '공연미디어학부',   category: '일반대', result: '최종합격' },
  { name: '이○연', university: '경민대학교',       dept: '연기예술과',       category: '전문대', result: '수시 최종합격' },
  { name: '엄○후', university: '경민대학교',       dept: '연기예술과',       category: '전문대', result: '수시 최종합격' },
  { name: '최○찬', university: '대경대학교',       dept: '연기예술과',       category: '전문대', result: '최종합격' },
];

const categoryColors: Record<string, { accent: string; glow: string }> = {
  예대:   { accent: '#e11d48', glow: 'rgba(225,29,72,0.18)' },
  일반대: { accent: '#94a3b8', glow: 'rgba(148,163,184,0.12)' },
  전문대: { accent: '#FFD700', glow: 'rgba(255,215,0,0.15)' },
  예고:   { accent: '#FFD700', glow: 'rgba(255,215,0,0.15)' },
};

const resultStyles: Record<string, { bg: string; text: string; label: string }> = {
  '수석합격':      { bg: 'rgba(225,29,72,0.18)',  text: '#ff6b8a', label: '수석합격' },
  '수시1차 합격':  { bg: 'rgba(255,180,0,0.15)',  text: '#FFD700', label: '수시1차 합격' },
  '수시 최종합격': { bg: 'rgba(255,180,0,0.15)',  text: '#FFD700', label: '수시 최종합격' },
  '최종합격':      { bg: 'rgba(34,197,94,0.12)',  text: '#4ade80', label: '최종합격' },
};

const ITEM_HEIGHT = 110;

function AdmissionCard({ item }: { item: typeof admissions2026[0] }) {
  const color = categoryColors[item.category] ?? categoryColors['일반대'];
  const badge = resultStyles[item.result] ?? resultStyles['최종합격'];

  return (
    <div
      className="relative rounded-2xl px-5 py-4 mx-1 overflow-hidden"
      style={{
        background: 'linear-gradient(135deg, rgba(255,255,255,0.06) 0%, rgba(255,255,255,0.02) 100%)',
        border: `1px solid ${color.accent}33`,
        height: `${ITEM_HEIGHT - 6}px`,
        minHeight: `${ITEM_HEIGHT - 6}px`,
      }}
    >
      {/* left accent bar */}
      <div
        className="absolute left-0 top-3 bottom-3 w-1 rounded-full"
        style={{ background: color.accent }}
      />

      {/* glow bg */}
      <div
        className="absolute inset-0 pointer-events-none"
        style={{ background: `radial-gradient(ellipse at 0% 50%, ${color.glow} 0%, transparent 70%)` }}
      />

      <div className="relative flex items-center gap-3">
        {/* Name badge */}
        <div
          className="flex-shrink-0 w-11 h-11 rounded-xl flex items-center justify-center font-black text-sm"
          style={{ background: `${color.accent}22`, color: color.accent, border: `1px solid ${color.accent}44` }}
        >
          {item.name}
        </div>

        <div className="flex-1 min-w-0">
          {/* University name - BIG */}
          <div
            className="font-black text-xl leading-tight truncate"
            style={{ color: '#ffffff', letterSpacing: '-0.02em' }}
          >
            {item.university}
          </div>

          {/* Dept + result row */}
          <div className="flex items-center gap-2 mt-1 flex-wrap">
            <span className="text-neutral-400 text-xs truncate">{item.dept}</span>
            <span
              className="text-xs font-bold px-2.5 py-0.5 rounded-full whitespace-nowrap flex-shrink-0"
              style={{ background: badge.bg, color: badge.text }}
            >
              {badge.label}
            </span>
          </div>
        </div>

        {/* Category tag */}
        <div
          className="flex-shrink-0 text-[10px] font-bold px-2.5 py-1 rounded-lg"
          style={{ background: `${color.accent}18`, color: color.accent, border: `1px solid ${color.accent}30` }}
        >
          {item.category}
        </div>
      </div>
    </div>
  );
}

export default function AdmissionsSection() {
  const [paused, setPaused] = useState(false);
  const col1 = admissions2026.slice(0, 11);
  const col2 = admissions2026.slice(11);
  const doubled1 = [...col1, ...col1];
  const doubled2 = [...col2, ...col2];

  const totalH1 = col1.length * ITEM_HEIGHT;
  const totalH2 = col2.length * ITEM_HEIGHT;

  return (
    <section id="admissions" className="py-24" style={{ background: '#0a0a0a' }}>
      <style>{`
        @keyframes scrollUp1 {
          0% { transform: translateY(0); }
          100% { transform: translateY(-${totalH1}px); }
        }
        @keyframes scrollUp2 {
          0% { transform: translateY(-${totalH2 * 0.3}px); }
          100% { transform: translateY(-${totalH2 * 1.3}px); }
        }
        .scroll-col-1 {
          animation: scrollUp1 ${col1.length * 2.4}s linear infinite;
        }
        .scroll-col-2 {
          animation: scrollUp2 ${col2.length * 2.2}s linear infinite;
        }
        .scroll-paused .scroll-col-1,
        .scroll-paused .scroll-col-2 {
          animation-play-state: paused;
        }
      `}</style>

      {/* Header */}
      <div className="max-w-6xl mx-auto px-8 text-center mb-14">
        <div className="inline-flex items-center gap-2 px-4 py-1.5 rounded-full mb-6" style={{ background: 'rgba(225,29,72,0.15)', border: '1px solid rgba(225,29,72,0.35)' }}>
          <span className="w-1.5 h-1.5 rounded-full bg-red-500 inline-block animate-pulse" />
          <span className="text-red-400 text-xs font-semibold tracking-widest uppercase">
            2026 합격자 발표
          </span>
        </div>
        <div className="flex items-center justify-center gap-4 mb-6 flex-wrap">
          <div className="flex items-center gap-2 px-5 py-2.5 rounded-full" style={{ background: 'rgba(255,255,255,0.06)', border: '1px solid rgba(255,255,255,0.12)' }}>
            <i className="ri-award-fill text-sm" style={{ color: '#e11d48' }} />
            <span className="text-neutral-200 text-sm font-semibold whitespace-nowrap">한예종 2년 연속 수시 1차 합격</span>
          </div>
          <div className="w-1 h-1 rounded-full bg-neutral-600 flex-shrink-0" />
          <div className="flex items-center gap-2 px-5 py-2.5 rounded-full" style={{ background: 'rgba(255,255,255,0.06)', border: '1px solid rgba(255,255,255,0.12)' }}>
            <i className="ri-trophy-fill text-sm" style={{ color: '#e11d48' }} />
            <span className="text-neutral-200 text-sm font-semibold whitespace-nowrap">SAC대회 2년 연속 본선 진출</span>
          </div>
        </div>
        <h2 className="font-serif-kr text-4xl md:text-5xl font-black text-white mb-4 leading-tight">
          2026학년도&nbsp;
          <span className="text-red-500">대학 합격자 명단</span>
        </h2>
        <p className="text-neutral-500 text-sm max-w-md mx-auto font-light leading-relaxed">
          찬연기아카데미의 체계적인 입시 커리큘럼이 만들어낸<br />
          빛나는 합격의 결과입니다
        </p>
      </div>

      {/* Scrolling Columns */}
      <div
        className={`max-w-5xl mx-auto px-8 ${paused ? 'scroll-paused' : ''}`}
        onMouseEnter={() => setPaused(true)}
        onMouseLeave={() => setPaused(false)}
      >
        <div
          className="relative flex gap-4 rounded-2xl overflow-hidden p-4"
          style={{ height: '560px', background: '#0f0f0f', border: '1px solid rgba(255,255,255,0.07)' }}
        >
          {/* Top fade */}
          <div className="absolute top-0 left-0 right-0 h-20 z-10 pointer-events-none" style={{ background: 'linear-gradient(to bottom, #0f0f0f, transparent)' }} />
          {/* Bottom fade */}
          <div className="absolute bottom-0 left-0 right-0 h-20 z-10 pointer-events-none" style={{ background: 'linear-gradient(to top, #0f0f0f, transparent)' }} />

          {/* Column 1 */}
          <div className="flex-1 overflow-hidden">
            <div className="scroll-col-1 flex flex-col gap-2">
              {doubled1.map((item, i) => (
                <AdmissionCard key={`c1-${i}`} item={item} />
              ))}
            </div>
          </div>

          {/* Divider */}
          <div className="w-px flex-shrink-0" style={{ background: 'rgba(255,255,255,0.07)' }} />

          {/* Column 2 */}
          <div className="flex-1 overflow-hidden">
            <div className="scroll-col-2 flex flex-col gap-2">
              {doubled2.map((item, i) => (
                <AdmissionCard key={`c2-${i}`} item={item} />
              ))}
            </div>
          </div>
        </div>

        {/* Pause hint */}
        <div className="text-center mt-4">
          <span className="text-neutral-600 text-xs tracking-wide">
            {paused ? '일시정지 중 · 마우스를 움직이면 재시작' : '마우스를 올리면 일시정지'}
          </span>
        </div>
      </div>

      {/* Bottom CTA */}
      <div className="max-w-5xl mx-auto px-8 mt-12">
        <div
          className="rounded-2xl p-8 flex items-center justify-between"
          style={{ background: 'rgba(225,29,72,0.1)', border: '1px solid rgba(225,29,72,0.25)' }}
        >
          <div>
            <div className="text-white font-bold text-lg mb-1">
              2027학년도 합격자 명단에 이름을 올리세요
            </div>
            <div className="text-neutral-500 text-sm">
              지금 무료 상담을 신청하고 전문 강사의 1:1 진단을 받아보세요
            </div>
          </div>
          <a
            href="#contact"
            onClick={(e) => {
              e.preventDefault();
              document.getElementById('contact')?.scrollIntoView({ behavior: 'smooth' });
            }}
            className="flex-shrink-0 px-7 py-3 rounded-full bg-red-600 text-white font-semibold text-sm hover:bg-red-700 transition-all duration-300 cursor-pointer whitespace-nowrap ml-8"
          >
            무료 상담 신청 <i className="ri-arrow-right-line ml-1" />
          </a>
        </div>
      </div>
    </section>
  );
}
